import { apiClient } from '../http'

export const marketingService = {
    async getActivePromo() {
        const response = await apiClient.get('/marketing/promos/active')
        return response.data
    },

    async markViewed(notificationId) {
        const response = await apiClient.post(
            `/marketing/promos/${notificationId}/viewed`
        )
        return response.data
    },

    async markClicked(notificationId) {
        const response = await apiClient.post(
            `/marketing/promos/${notificationId}/clicked`
        )
        return response.data
    },
}
